module.exports = __webpack_public_path__ + "static/media/btn_events_1075_725.4dce9fc0.png";